import acquirer from '@/view/slt/acquirer/index.vue'
import merchant from '@/view/slt/merchant/index.vue'
import bankFlow from '@/view/slt/bankFlow/index.vue'
import bankFlowDetail from '@/view/slt/bankFlow/detail.vue'
import bath from '@/view/slt/bath/index.vue'
import settle from '@/view/slt/settle/index.vue'
import signinfo from '@/view/slt/sign-info/index.vue'


export default [
    { path: '/slt/acquirer', component: acquirer, meta: '收单机构配置' },
    { path: '/slt/merchant', component: merchant, meta: '收单商户配置' },
    { path: '/slt/sign-info', component: signinfo, meta: '商户密钥配置' },
    { path: '/slt/bankFlow', component: bankFlow, meta: '来账流水管理' },
    { path: '/slt/bankFlow/detail', component: bankFlowDetail, meta: '来账流水详情' },
    { path: '/slt/bath', component: bath, meta: '订单批次管理' },
    { path: '/slt/settle', component: settle, meta: '订单清算管理' },

]
